import TwoFactorAuth from 'features/auth/ui/two-factor-authentication/ui';

export const TwoFactor = () => {
  return <TwoFactorAuth />;
};
